/* eslint-disable react/no-array-index-key */
// dependencies
import { useApolloClient } from "@apollo/client";
import * as Sentry from "@sentry/react";
import React, { useEffect } from "react";

import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Builder from "./Builder";
import QueryButton from "./QueryButton";

// query builder store
import useQueryBuilderStore from "./store";

// styles
import css from "./QueryBuilder.module.scss";

const QueryBuilder = () => {
	const [filterUpdate, selectedFilterGroup, setClient, setFilterUpdate, initValueLabelMaps, handleRemoveFilterGroup] =
		useQueryBuilderStore((state) => [
			state.filterUpdate,
			state.selectedFilterGroup,
			state.setClient,
			state.setFilterUpdate,
			state.initValueLabelMaps,
			state.handleRemoveFilterGroup,
		]);

	const client = useApolloClient();

	useEffect(() => {
		const filtersCopy = [...filterUpdate];
		setClient(client);
		setFilterUpdate(filtersCopy);
		initValueLabelMaps();
	}, []);

	return (
		<Sentry.ErrorBoundary
			fallback={({ resetError }) => {
				return (
					<div>
						<div className={css.failedSummary}>
							<div className={css.summaryHeader}>
								<div className={css.timesIcon}>
									<FontAwesomeIcon icon={faTimesCircle} />
								</div>
								<div>
									Unable to add filter condition at this time. Click &quot;Continue&quot; to return to
									where you left off.
								</div>
							</div>
						</div>
						<QueryButton
							onClick={() => {
								handleRemoveFilterGroup(selectedFilterGroup);
								resetError();
							}}
							text="Continue"
						/>
					</div>
				);
			}}
		>
			<Builder />
		</Sentry.ErrorBoundary>
	);
};

export default QueryBuilder;
